import React from 'react';
import { FormControl, FormControlLabel, RadioGroup, Radio } from '@material-ui/core';

type Item = {
  value: string
  content: React.ReactElement
}

interface FormRadioButtonsProps {
  disabled?: boolean
  value: string
  onChange: (targetString: string) => void
  items: Array<Item>
  field: string
}

export default function FormRadioButtons ({
  disabled,
  value,
  onChange: onChangeProp,
  items,
  field
}: FormRadioButtonsProps) {
  return (
    <FormControl component='fieldset'>
      <RadioGroup>
        {
        items.map(item => (
          <FormControlLabel
            key={item.value}
            checked={item.value === value}
            disabled={disabled}
            name={field}
            onChange={(e) => onChangeProp((e as React.ChangeEvent<HTMLInputElement>).target.value)}
            value={item.value}
            control={<Radio color='primary' />}
            label={item.content}
          />
        ))
        }
      </RadioGroup>
    </FormControl>
  );
}
